module.exports = __webpack_public_path__ + "img/new_message.af79fbd6.png";